export default "__VITE_ASSET__q8KN6GEp__"